import React from 'react';
import Table from '../../../Payments/Table';
import { reduceResolution, wbp } from 'Theme';
import { Box, TableCell, TableRow } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useCommonStyles as useTableStyles } from '../../../Payments/Table/CommonStyles';
import { BookingsSummaryReport } from 'model/BookingsReport';
import { PriceFormat } from 'components/UI';

interface SummaryDetailTableProps {
    loading: boolean;
    summary: BookingsSummaryReport | null;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            paddingTop: 8,

            [theme.breakpoints.down('sm')]: {
                backgroundColor: '#FAFAFA'
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: 16,
                margin: '0px -24px'
            }
        },
        header: {
            [theme.breakpoints.down(wbp)]: {
                paddingBottom: `${reduceResolution(63)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingBottom: '63px'
            }
        },
        cell: {
            fontWeight: 400,
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(15)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '15px'
            }
        },
        cellHeader: {
            padding: '20px 0px'
        },
        priceContainer: {
            display: 'flex',
            alignItems: 'center'
        }
    })
);

export const SummaryDetailTable: React.FunctionComponent<SummaryDetailTableProps> = props => {
    const classes = useStyles();
    const tableStyles = useTableStyles();

    const headersTable = (
        <>
            <TableCell className={tableStyles.headerCell}>Total Bookings</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Clients</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Pets</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Services</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Add-Ons</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Products</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Custom Items</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Value</TableCell>
            <TableCell className={tableStyles.headerCell}>Average Booking Value</TableCell>
        </>
    );

    const rowsClientDetail = (
        <>
            {props.summary && (
                <>
                    <TableRow>
                        <TableCell className={tableStyles.cell}>{props.summary.totalBookings}</TableCell>
                        <TableCell className={tableStyles.cell}>{props.summary.totalClients}</TableCell>
                        <TableCell className={tableStyles.cell}>{props.summary.totalPets}</TableCell>
                        <TableCell className={tableStyles.cell}>{props.summary.totalServices}</TableCell>
                        <TableCell className={tableStyles.cell}>{props.summary.totalAddons}</TableCell>
                        <TableCell className={tableStyles.cell}>{props.summary.totalProducts}</TableCell>
                        <TableCell className={tableStyles.cell}>{props.summary.totalCustomItems}</TableCell>
                        <TableCell className={tableStyles.cell}>
                            <PriceFormat price={props.summary.totalValue?.toFixed(2) || ''} />
                        </TableCell>
                        <TableCell className={tableStyles.cell}>
                            <PriceFormat price={props.summary.averageBookingValue?.toFixed(2) || ''} />
                        </TableCell>
                    </TableRow>
                </>
            )}
        </>
    );

    return (
        <Box className={classes.root}>
            <Table
                headers={headersTable}
                rows={props.summary ? rowsClientDetail : <></>}
                loading={props.loading}
                withoutColor={true}
            />
        </Box>
    );
};

export default SummaryDetailTable;
